export default __webpack_public_path__ + "static/media/icon-select-file.9c1792b2.svg";